module.exports = __webpack_public_path__ + "img/start.b37b1c60.png";